<template>
  <div
    class="banner-container"
    :style="{ height: height, maxHeight: maxHeight }"
  >
    <swipe
      :loop="loop"
      :autoplay="interval"
      height="100%"
      :show-indicators="false"
      class="swiper-ad"
      dots-class="dot"
    >
      <swipe-item
        class="swiper-demo-img"
        v-for="(item, index) in data"
        :key="index"
      >
        <div
          class="banner-img"
          :style="{
            backgroundImage: `url(${item.src})`,
            backgroundRepeat: 'no-repeat',
            backgroundSize: '100% auto',
            backgroundPosition: 'bottom center',
          }"
          @click="onClickUrl(item)"
        ></div>
      </swipe-item>
    </swipe>
  </div>
</template>

<script>
import { getSafeAreaTopStyle, getSafeAreaTop } from "@/adapter/safeArea";
import { buriedPoint } from "@home/lib/buriedPoint";
import Swipe from "vant/es/swipe";
import SwipeItem from "vant/es/swipe-item";
import "vant/es/swipe/style/index";
export default {
  name: "BannerSwiper",
  components: {
    Swipe,
    SwipeItem,
  },
  props: {
    data: {
      type: Array,
      default: () => [],
    },
    loop: {
      type: Boolean,
      default: true,
    },
    auto: {
      type: Boolean,
      default: true,
    },
    interval: {
      type: Number,
      default: 4000,
    },
  },
  data() {
    return {
      height: `calc(${getSafeAreaTop()}px + 37.9vw)`,
      maxHeight: `calc(${getSafeAreaTop()}px + 227px)`,
    };
  },
  methods: {
    onClickUrl(item) {
      const url = item.url;
      if (!url) return;
      // 埋点事件
      buriedPoint("Button_Click_AD", { url });
      if (url.includes("auth=true")) {
        window.$httpUtil.instance
          .get(url)
          .then((res) => {
            let data = res.data || {};
            if (data.data && data.data.redirectUrl) {
              $jump.openLink(data.data.redirectUrl);
            }
          })
          .catch((err) => {
            console.log(err);
          });
        return;
      }
      if (url.startsWith("/")) {
        $jump.goLocPage(url);
        return;
      }
      if (url.startsWith("ztrip:")) {
        this.$router.push({
          path: url.split(":")[1],
        });
        return;
      }
      if (url.includes("common/teamActivity")) {
        $jump.goLocPage("/common/teamActivity");
      } else {
        $jump.openLink(url);
      }
    },

    geturlparams(url) {
      let urlstr = url.split("?")[1];
      let obj = {};
      let paramsarr = urlstr.split("&");
      for (let i = 0, len = paramsarr.length; i < len; i++) {
        let arr = paramsarr[i].split("=");
        obj[arr[0]] = arr[1];
      }
      return obj;
    },
  },
};
</script>
<style scoped lang="less">
.swiper-ad {
  width: 100%;
  height: 100%;
}
.swiper-ad .banner-img {
  height: 100%;
  width: 100%;
}
.banner-container {
  width: 100%;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 0;
}
</style>
